/**
 * State used in rendering TableHeader
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
